import { Component, OnInit, Inject, ViewChild, TemplateRef, ElementRef, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { trigger, state, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-jspl-details-view',
  templateUrl: './jspl-details-view.component.html',
  styleUrls: ['./jspl-details-view.component.scss'],
  animations: [
    trigger('slideInOutAnimation', [
    
      state('*', style({
    
      })),
      transition(':enter', [
        style({
          transform: 'translateY(100%)',
          opacity: 1
        }),
        animate('.5s ease-in-out', style({
          transform: 'translateY(0)',
          opacity: 1
        }))
      ]),
      transition(':leave', [
        animate('.5s ease-in-out', style({
          transform: 'translateY(100%)',
          opacity: 0
        }))
      ])
    ])
    ]
})
export class JsplDetailsViewComponent implements OnInit {
  rowData:any
  vehicle_number:any;

  constructor(private dialogRef: MatDialogRef<JsplDetailsViewComponent>, @Inject(MAT_DIALOG_DATA) private parentData: any,) { }

  ngOnInit(): void {
    this.rowData = this.parentData;
    this.vehicle_number = this.rowData[0].value
  }
  closeModal() {
    this.dialogRef.close();
  }

}
